import {createComponent} from '../bridge/create-component';
import type {BridgeComponentOptions} from '../bridge/types';
import type {ConfirmPaymentParams, PaymentModalProps} from './types';
import {config} from '../config';
import type {PaymentResult} from '../types';
import {createContainerTemplate} from '../container';

export * from './types';

const componentOptions: BridgeComponentOptions<PaymentModalProps> = {
  tag: 'monei-payment-modal',
  url: config.paymentModalUrl,
  dimensions: {
    width: '100%',
    height: '100%'
  },
  autoResize: {
    width: false,
    height: false
  },
  aliases: {
    style: 'innerStyle'
  },
  containerTemplate: createContainerTemplate({
    background: 'transparent',
    fadeOnRender: false,
    allowTransparency: true
  })
};

export const PaymentModal = createComponent<PaymentModalProps>(componentOptions);

export const confirmPayment = (params: ConfirmPaymentParams) => {
  const rootNode = document.createElement('div');
  const bodyOverflow = document.body.style.overflow;

  // Apply fullscreen styles BEFORE rendering so the iframe gets the correct
  // viewport size from the start (prevents mobile media query from matching).
  Object.assign(document.body.style, {overflow: 'hidden'});
  Object.assign(rootNode.style, {
    position: 'fixed',
    overflow: 'hidden',
    display: 'block',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    width: '100%',
    height: '100%',
    zIndex: '99999'
  });
  document.body.appendChild(rootNode);

  let modal: InstanceType<typeof PaymentModal> | null = null;

  const cleanup = () => {
    void modal?.destroy();
    modal = null;
    Object.assign(document.body.style, {overflow: bodyOverflow});
    if (rootNode.parentNode) rootNode.parentNode.removeChild(rootNode);
  };

  return new Promise<PaymentResult>((resolve, reject) => {
    modal = new PaymentModal({
      ...params,
      isOpen: true,
      onResult: (result: any) => {
        resolve(result);
        cleanup();
      },
      onError: (error: any) => {
        reject(error);
        cleanup();
      }
    } as any);
    modal.render(rootNode).catch((err) => {
      cleanup();
      reject(err);
    });
  });
};
